const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    description: '采用银行级128位SSL加密技术，多重身份验证体系，保障您的账户与资金安全。',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速体验',
    description: '秒级充值到账，快速提现处理，流畅的游戏体验，让您畅享不间断的娱乐时光。',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: '专业服务',
    description: '7×24小时全天候客户服务，专业团队快速响应，为您解决任何疑问与问题。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端互通',
    description: '支持PC端、手机端、App多平台无缝切换，数据实时同步，随时随地畅享服务。',
  },
];

export default function FeaturesSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            为什么选择<strong className="text-primary-500">开云</strong>
          </h2>
          <p className="text-secondary-600 max-w-2xl mx-auto">
            开云平台始终以用户为中心，致力于提供安全、稳定、极致的在线娱乐体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group p-6 md:p-8 rounded-xl bg-background-100 border border-background-200/50 hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-500/10 flex items-center justify-center mb-5 group-hover:bg-primary-500/20 transition-colors duration-300">
                <i className={`${feature.icon} text-2xl text-primary-500 w-6 h-6 flex items-center justify-center`}></i>
              </div>
              <h3 className="text-lg font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-secondary-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}